import { render, staticRenderFns } from "./SaleCheck.vue?vue&type=template&id=40b9852d&scoped=true&"
import script from "./SaleCheck.vue?vue&type=script&lang=js&"
export * from "./SaleCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b9852d",
  null
  
)

export default component.exports